<div class="w-full h-full relative">
  <app-viewers></app-viewers>
  <app-overlay-btns></app-overlay-btns>
</div>